'use client'

import { useRef, useState } from 'react'
import { Menu } from 'lucide-react'
import type { ExamSearchEntry } from '@/data/exams/search-index'
import { MobileMenuSheet } from './MobileMenuSheet'

const CLOSE_MS = 200

interface MobileMenuProps {
  entries: ExamSearchEntry[]
}

export function MobileMenu({ entries }: MobileMenuProps) {
  const [open, setOpen] = useState<boolean>(false)
  const [closing, setClosing] = useState<boolean>(false)
  const closeTimer = useRef<ReturnType<typeof setTimeout> | null>(null)

  const requestClose = (): void => {
    if (closing) return
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)')
    if (reduced.matches) {
      setOpen(false)
      return
    }
    setClosing(true)
    closeTimer.current = setTimeout(() => {
      setOpen(false)
      setClosing(false)
    }, CLOSE_MS)
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Open menu"
        aria-expanded={open}
        aria-haspopup="dialog"
        className="text-ink hover:bg-surface flex h-11 w-11 items-center justify-center rounded-full transition-colors lg:hidden"
      >
        <Menu size={20} />
      </button>
      {open && (
        <MobileMenuSheet
          entries={entries}
          closing={closing}
          onClose={requestClose}
        />
      )}
    </>
  )
}
